import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxDataWidgetComponent,
  OnyxIconComponent,
  OnyxInformationListComponent,
  OnyxInformationRowComponent,
  OnyxLanguagePipe,
  OnyxModalComponent,
} from '@onyx/angular';
import { sumBy } from 'lodash';
import type { OrderLoadingPointForm } from '../../../../../dashboard/orders/common/helpers/order-form.helper';
import { OrderHelper } from '../../../../../dashboard/orders/common/helpers/order.helper';
import type { OrderLoadingGood } from '../../../../../dashboard/orders/common/interfaces/order-point';
import { OrderFormService } from '../../../../../dashboard/orders/common/services/order-form.service';
import type { OrderUnloadingPointForm } from '../../../../../dashboard/orders/order-form/order-points-form/order-unloading-point-form/order-unloading-point-form.component';
import { DictionaryCode } from '../../../../enums/dictionary-code';
import { GoodsSizeType } from '../../../../enums/goods-size-type';
import { DimensionsPipe } from '../../../../pipes/dimensions.pipe';
import { GoodQuantityPipe } from './../../../../pipes/good-quantity.pipe';

export interface RoutePointGoodsModalComponentData {
  point: OrderLoadingPointForm | OrderUnloadingPointForm;
  goods: OrderLoadingGood[];
}

@Component({
  selector: 'app-route-point-goods-modal',
  imports: [
    OnyxModalComponent,
    TranslatePipe,
    OnyxDataWidgetComponent,
    OnyxIconComponent,
    OnyxLanguagePipe,
    TranslatePipe,
    DecimalPipe,
    OnyxInformationRowComponent,
    GoodQuantityPipe,
    OnyxInformationListComponent,
    DimensionsPipe,
  ],
  templateUrl: './route-point-goods-modal.component.html',
  styleUrl: './route-point-goods-modal.component.scss',
})
export class RoutePointGoodsModalComponent {
  protected readonly data =
    inject<RoutePointGoodsModalComponentData>(DIALOG_DATA);
  protected readonly dialogRef = inject(DialogRef<void>);
  private readonly orderFormService = inject(OrderFormService, {
    optional: true,
  });

  protected readonly DictionaryCode = DictionaryCode;
  protected readonly GoodsSizeType = GoodsSizeType;

  protected readonly totalGoods:
    | (Pick<OrderLoadingGood, 'unit' | 'quantity'> & { quantityUnit: string })
    | null;
  protected readonly totalWeight: number;

  protected readonly goods: (OrderLoadingGood & {
    color: string | undefined;
  })[];

  constructor() {
    const data = this.data;

    const { goods } = data;

    this.totalGoods = null;
    if (goods.every((good) => good.size?.type === goods[0].size?.type)) {
      this.totalGoods = {
        unit: goods[0].unit,
        quantity:
          sumBy(goods, (good) => OrderHelper.getGoodQuantity(good) ?? 0) /
          10 ** OrderHelper.getGoodSizeDecimalPlaces(goods[0].size?.type),
        quantityUnit: OrderHelper.getGoodUnit(goods[0].size?.type),
      };
    }

    this.totalWeight = sumBy(goods, ({ totalWeight }) => totalWeight);

    const formGoods = this.orderFormService?.getGoods();
    this.goods = goods.map((good) => ({
      ...good,
      color: formGoods?.find((formGood) => formGood.good.uuid === good.uuid)
        ?.goodColor,
    }));
  }
}
